<template>
  <div 
    class="grid-board" 
    :style="{
      display: 'grid', 
      gridTemplateColumns: `repeat(${width}, 1fr)`,
      gap: '0',
      width: '100%',
      maxWidth: '600px'
    }"
  >
    <div 
      v-for="(cell, index) in cells" 
      :key="index"
      class="grid-cell"
      :class="{ 'obstacle': isObstacle(cell) }"
      :style="{
        backgroundColor: isObstacle(cell) ? 'rgba(128, 128, 128, 0.5)' : 'transparent',
        aspectRatio: '1/1',
        minWidth: '30px',
        minHeight: '30px',
        border: '1px solid #333'
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'GridBoard',
  props: {
    width: { type: Number, default: 8 },
    height: { type: Number, default: 8 },
    cellColor: { 
      type: String, 
      default: 'transparent' // Changed default to transparent
    },
    obstacles: { type: Array, default: () => [] }
  },
  computed: {
    cells() {
      return Array.from(
        { length: this.width * this.height }, 
        (_, index) => ({
          x: index % this.width,
          y: Math.floor(index / this.width)
        })
      );
    }
  },
  methods: {
    isObstacle(cell) {
      return this.obstacles.some(
        obstacle => 
          obstacle.x === cell.x && obstacle.y === cell.y
      );
    }
  }
}
</script>

<style scoped>
.grid-board {
  margin: 0 auto;
  border-collapse: collapse;
}

.grid-cell {
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  margin: 0;
  padding: 0;
}

.grid-cell:hover {
  background-color: rgba(0, 0, 0, 0.05); /* Subtle hover effect */
}

.grid-cell.obstacle {
  background-color: rgba(128, 128, 128, 0.5) !important; /* Semi-transparent gray */
}
</style>